import SearchView from '@app/Search/View'
import KnowledgeSearch from '@app/Search/KnowledgeSearch'
import SearchCategoryView from '@app/Search/CategoryView'

export default function install(Vue) {
  Vue.component(SearchView.name, SearchView)
  Vue.component(KnowledgeSearch.name, KnowledgeSearch)
  Vue.component(SearchCategoryView.name, SearchCategoryView)
}
